<template>
  <div class="check-out">
    <div class="checkout-container">
      <div class="page-title">确认订单</div>
      <div class="checkout-left">
        <div class="address-box">
          <div class="address-container">
            <div class="address-top">
              <div class="top-title">确认收货地址</div>
              <div class="top-btn-box">
                <div class="btn-items" @click="add_address">使用新地址</div>
                <div
                  class="btn-items"
                  @click="$router.push({ name: 'Address' })"
                >
                  管理地址
                </div>
              </div>
            </div>
            <div class="address-list">
              <div
                :class="[
                  'address-item',
                  { active: form.address_id == item.id },
                ]"
                v-for="(item, index) in visible_address"
                :key="index"
                @click="selectAddress(item)"
              >
                <img
                  :src="
                    form.address_id == item.id
                      ? require('../../assets/images/icon-mall-address-active.png')
                      : require('../../assets/images/icon-mall-address.png')
                  "
                  alt=""
                  class="address-item-icon"
                />
                <div class="address-item-content">
                  <div class="top-content">
                    <span class="is-default" v-if="item.is_default">默认</span>
                    <span>{{ item.province }}</span>
                    <span>{{ item.city }}</span>
                    <span>{{ item.zone }}</span>
                  </div>
                  <div class="address-content">
                    {{ item.address }}
                  </div>
                  <div class="address-name-phone">
                    <span>{{ item.contact_person }}</span>
                    <span>{{ item.contact_mobile }}</span>
                  </div>
                </div>
                <div @click.stop="edit_address(item.id)" class="edit-icon">
                  编辑
                </div>
              </div>
            </div>
            <div
              class="show-all-btn"
              v-if="address_list.length > 4"
              @click="show_all_address = !show_all_address"
            >
              {{ show_all_address ? "收起" : "显示全部地址" }}
              <Icon
                :class="[{ 'arrow-transform': show_all_address }]"
                type="ios-arrow-down"
                size="12"
              />
            </div>
          </div>
        </div>
        <div class="product-box">
          <div class="product-list">
            <div class="list-title">确认订单信息</div>
            <table v-for="(item, index) in goods_list" :key="index">
              <tbody>
                <tr>
                  <th colspan="3">
                    <div class="product-shop-title">
                      <img
                        src="@/assets/images/icon-mall-store-red.png"
                        alt=""
                        class="icon-shop"
                      />
                      <div class="shop-name">{{ item.shop_name }}</div>
                      <img
                        src="@/assets/images/icon-mall-cart-service.png"
                        alt=""
                        class="service-icon"
                        @click="showChat(item.designer)"
                        v-if="item.designer.id != userInfo.id"
                      />
                    </div>
                  </th>
                </tr>
                <tr
                  v-for="(goods, goods_index) in item.goods_list"
                  :key="goods_index"
                >
                  <td style="width: 60%">
                    <div class="product-info-column">
                      <img
                        :src="goods.product_image | default_img"
                        alt=""
                        class="cover"
                      />
                      <div class="text-box">
                        <div class="product-name">{{ goods.product_name }}</div>
                        <div class="product-spec">{{ goods.spec_text }}</div>
                      </div>
                    </div>
                  </td>
                  <td style="width: 20%">
                    <div class="num-column">
                      {{ goods.quantity }}
                      <!-- <div :class="['minus-btn',{'can-not':!cart.num || cart.num <2}]" @click="onCartNumChange('minus',cart,index,cart_index)">-</div> -->
                      <!-- <input disabled v-model="goods.quantity" type="text" class="num-input"> -->
                      <!-- <div class="plus-btn" @click="onCartNumChange('plus',cart,index,cart_index)">+</div> -->
                    </div>
                  </td>
                  <td style="width: 20%">
                    <div class="price-column">
                      <div class="price">¥{{ goods.price }}</div>
                      <div class="tag-price">吊牌价¥{{ goods.tag_price }}</div>
                      <div class="logistics-price">
                        包邮<span v-if="false">¥0.00</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="checkout-right">
        <div class="right-box-container">
          <div class="right-top-title">
            付款详情
            <div class="product-count">
              共<span>{{ goods_total.length }}</span
              >件商品
            </div>
          </div>
          <div class="right-product-imgs">
            <img
              v-for="(item, index) in goods_total"
              :key="index"
              :src="item.product_image | default_img"
              alt=""
              class="product-img"
            />
          </div>
          <div class="pay-list">
            <div
              class="pay-item"
              v-for="(item, index) in pay_items"
              :key="index"
            >
              <div class="pay-item-label">
                {{ item.title }}
              </div>
              <div class="pay-item-value">¥{{ item.amount }}</div>
            </div>
            <!-- <div class="pay-item">
                            <div class="pay-item-label">
                                运费
                            </div>
                            <div class="pay-item-value">¥18.88</div>
                        </div> -->
          </div>
          <div
            class="integral"
            v-if="
              pointSetting.shoppingDeductPoint > 0 &&
              pointSetting.maxDeductRatio > 0
            "
          >
            <label class="checkbox-label">
              <input
                type="checkbox"
                :checked="usePointDeduct"
                @change="switchPointChange"
              />
              积分抵扣
              <span>(当前账号积分{{ userInfo.point || 0 }})</span>
            </label>
            <div class="checkbox-value">¥{{ point_pay_money }}</div>
          </div>
          <div class="pay-type-box">
            <div class="pay-type-wrapper">
              <div
                class="pay-type-item"
                :class="{ 'pay-disabled': isPayDisabled(item) }"
                v-for="(item, index) in pay_list"
                :key="index"
              >
                <input
                  type="checkbox"
                  :checked="item.checked"
                  :disabled="isPayDisabled(item)"
                  @change="change_payment(item)"
                />
                <img :src="item.icon" alt="" class="pay-type-icon" />
                {{ item.name
                }}{{
                  item.type === "balance"
                    ? `(余额:${userInfo.available_balance})`
                    : ""
                }}
              </div>
            </div>
          </div>
          <div class="pay-total">
            <div class="pay-total-label">实付款:</div>
            <div class="pay-total-value">
              ¥{{ real_pay_price | price_format }}
            </div>
          </div>
          <div class="pay-btn-box">
            <div class="back-btn" @click="$router.back()">返回</div>
            <div class="pay-btn" @click="onOrderPay">确认支付</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 地址编辑 -->
    <!-- height="520px" -->
    <popup :show.sync="is_popup_show" width="490px" @on-close="close">
      <h2>添加收货地址</h2>
      <div class="form">
        <div class="form-group">
          <div class="form-label">收货人：</div>
          <div class="form-control">
            <input
              type="text"
              class="input"
              placeholder="请输入收货人"
              v-model="form_data.contact_person"
            />
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">手机号：</div>
          <div class="form-control">
            <input
              type="text"
              class="input"
              placeholder="请输入手机号"
              maxlength="11"
              v-model="form_data.contact_mobile"
            />
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">所在地区：</div>
          <div class="form-control">
            <Cascader
              class="input1"
              :data="region"
              v-model="value"
              placeholder="请选择省/市/区/街道"
            ></Cascader>
          </div>
        </div>

        <div class="form-group">
          <div class="form-label">详细地址：</div>
          <div class="form-control">
            <textarea
              placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息"
              v-model="form_data.address"
            />
          </div>
        </div>
        <div class="form-group">
          <div class="form-label"></div>
          <div class="form-control">
            <input type="checkbox" v-model="form_data.is_default" />是否默认地址
          </div>
        </div>
        <div class="btn-submit" @click="save">保存地址</div>
      </div>
    </popup>
    <Chat ref="chat"></Chat>
  </div>
</template>
<script>
import {
  AddressList,
  createOrder,
  GetAddress,
  getSetting,
  MallDetailInCheckout,
  mallCalculateFreight,
  orderCheckout,
  orderEstimate,
  orderPay,
  SaveAddress,
} from "@/api/index";
import Popup from "@/components/Popup.vue";
import region from "@/utils/region.js";
import { checkMobile } from "@/utils/util";
import { mapState } from "vuex";
const form_data = {
  id: 0,
  contact_person: "",
  contact_mobile: "",
  province: "",
  city: "",
  zone: "",
  address: "",
  is_default: 0,
};
export default {
  components: {
    Popup,
  },
  data() {
    return {
      address_list: [],
      pay_list: [
        {
          name: "微信支付",
          icon: require("../../assets/images/icon_weixin@2x.png"),
          type: "wechat",
          checked: true,
        },
        {
          name: "支付宝支付",
          icon: require("../../assets/images/icon_zhifubao@2x.png"),
          type: "alipay",
          checked: false,
        },
        {
          name: `余额支付`,
          icon: require("../../assets/images/icon-balance-pay.png"),
          type: "balance",
          checked: false,
        },
      ],
      form: {
        address_id: "",
        from: "",
        cart_uuid: [],
        spec_id: "",
        num: "",
        order_uuid: "",
      },
      form_data: { ...form_data },
      is_popup_show: false,
      value: [],
      region: region,
      show_all_address: false,
      goods_list: [],
      pay_items: [],
      usePointDeduct: true,
      pointSetting: {
        shoppingDeductPoint: 0,
        maxDeductPoint: 0,
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
    visible_address() {
      if (this.show_all_address) {
        return this.address_list;
      } else {
        return this.address_list.slice(0, 4);
      }
    },
    goods_total() {
      console.log("this.goods_list", Object.values(this.goods_list));
      const arr = Object.values(this.goods_list);
      if (!this.goods_list || !Array.isArray(arr) || !arr.length) return [];
      try {
        console.log("bbbb");
        const data = arr
          .map((item) => {
            console.log("item.goods_list", item.goods_list);
            // 确保 item.goods_list 存在且为数组
            if (item.goods_list && Array.isArray(item.goods_list)) {
              return item.goods_list;
            }
            return [];
          })
          .flat(); // 使用 flat() 展平嵌套数组
        console.log("data=>cpt", data);
        return data;
      } catch (error) {
        console.error("Error processing goods_total:", error);
        return [];
      }
    },
    total_price() {
      return this.pay_items.reduce((sum, item) => {
        return Number(sum) + Number(item.amount);
      }, 0);
    },
    real_pay_price() {
      return this.total_price - Math.abs(this.point_pay_money);
    },
    // 最终应付金额（用于判断余额是否足够支付），供支付勾选策略使用
    finalPayPrice() {
      return Number(this.real_pay_price || 0);
    },
    point_pay_money() {
      if (this.usePointDeduct) {
        var maxDeductPrice =
          (this.pointSetting.maxDeductRatio / 100) * this.total_price;
        if (
          this.userInfo.point * this.pointSetting.shoppingDeductPoint >
          maxDeductPrice
        ) {
          var point_pay_money = maxDeductPrice;
        } else {
          var point_pay_money =
            this.userInfo.point * this.pointSetting.shoppingDeductPoint;
        }
        return point_pay_money.toFixed(2);
      }
      return 0;
    },
  },
  watch: {
    // 应付金额/余额变化时，纠正已选支付方式，避免出现非法组合
    real_pay_price() {
      this.normalizePayType();
    },
    "userInfo.available_balance"() {
      this.normalizePayType();
    },
  },
  async mounted() {
    await this.onGetAddressList();
    await this.$store.dispatch("getUser");
    const {
      uuid,
      // spec_id, num,
      product_uuid,
      from,
      wholesale_data,
    } = this.$route.query;
    if (!from) {
      this.$layer.msg("下单参数异常");
      return;
    }
    this.form.from = from;
    if (from === "cart") {
      if (!uuid) {
        this.$layer.msg("未选择商品");
        this.$router.back();
        return;
      }
      this.form.cart_uuid = uuid.split(",");
    }
    if (from === "buynow") {
      const whole_data = JSON.parse(wholesale_data);
      if (!whole_data.length) {
        this.$layer.msg("未选择商品");
        this.$router.back();
        return;
      }
      this.form.wholesale_data = whole_data;
      this.form.product_uuid = product_uuid;
      // this.form.spec_id = spec_id;
      // this.form.num = num;
    }
    if (from === "order-list") {
      this.form.order_uuid = uuid;
    }
    console.log("form", this.form);
    if (from != "order-list") {
      this.onOrderEstimate();
    } else {
      this.onOrderDetail();
    }
    this.getPointSetting();
  },
  methods: {
    async getPointSetting() {
      let { data } = await getSetting({ code: "user", key: "pointSetting" });
      if (data) {
        this.pointSetting = data;
      }
    },
    switchPointChange(e) {
      this.usePointDeduct = !this.usePointDeduct;
    },
    showChat(user) {
      this.$refs["chat"].showChat(user);
    },
    // 重新支付场景：切换/新增/修改地址后，同步订单收货地址并重算运费，再拉取详情
    async recalculateOrderFreight() {
      try {
        await mallCalculateFreight({
          uuid: this.form.order_uuid,
          address_id: this.form.address_id,
        });
      } catch (e) {
        console.log("err-calculate-freight", e);
      } finally {
        this.onOrderDetail();
      }
    },
    async onOrderDetail() {
      try {
        const { code, msg, data } = await MallDetailInCheckout({
          uuid: this.$route.query.uuid,
        });
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        console.log("data", data);
        this.goods_list = data.base_data;
        this.pay_items = data.total_data;
      } catch (e) {
        console.log("err-order-detail", e);
      }
    },
    async onCreateOrder() {
      try {
        const { code, msg, data } = await createOrder(this.form);
        return { code, msg, data };
      } catch (e) {
        console.log("err-create-order", e);
        return e;
      }
    },
    async onOrderCheckout(param, pay_param) {
      try {
        const { code, msg, data } = await orderCheckout({
          ...param,
          pay_param,
        });
        return { code, msg, data };
      } catch (e) {
        console.log("err-order-checkout", e);
        return e;
      }
    },
    async onOrderPay() {
      if (!this.form.address_id) {
        this.$layer.msg("请选择收货地址");
        return;
      }
      try {
        let uuid = this.form.order_uuid;
        if (this.form.from != "order-list") {
          //>创建订单
          const create = await this.onCreateOrder();
          console.log("create", create);
          if (create.data.code > 0) {
            this.$layer.msg(create.data.msg);
            return;
          }
          this.$layer.msg("订单创建中...");
          uuid = create.data.uuid;
        }
        if (!Array.isArray(uuid)) {
          uuid = uuid.split(",");
        }
        //>订单checkout
        let payTypes = this.pay_list
          .filter((i) => {
            return i.checked;
          })
          .map((i) => {
            return i.type;
          });
        if (payTypes.length == 0) {
          return this.$layer.msg("请选择支付方式");
        }
        let pay_param = {
          use_balance: false,
          use_wechat: false,
          use_alipay: false,
          usePointDeduct: this.usePointDeduct,
        };
        if (payTypes.indexOf("balance") >= 0) {
          pay_param.use_balance = true;
        }
        if (payTypes.indexOf("wechat") >= 0) {
          pay_param.use_wechat = true;
        }
        if (payTypes.indexOf("alipay") >= 0) {
          pay_param.use_alipay = true;
        }
        const param = {};
        param.address_id = this.form.address_id;
        param.uuid = uuid;
        const checkout = await this.onOrderCheckout(param, pay_param);
        console.log("checkout", checkout);
        if (checkout.code > 0) {
          this.$layer.msg(checkout.msg);
          return;
        }
        //>只有余额支付操作
        let is_online_pay = pay_param.use_wechat || pay_param.use_alipay;
        if (pay_param.use_balance && !is_online_pay) {
          this.payBalance(checkout.data.uuid);
          return;
        }
        //有使用余额
        if (
          pay_param.use_balance &&
          Number(this.total_price - this.point_pay_money) <
            Number(this.userInfo.available_balance)
        ) {
          this.payBalance(checkout.data.uuid);
          return;
        }
        //积分全部抵扣
        if (this.usePointDeduct && this.point_pay_money >= this.total_price) {
          this.payBalance(checkout.data.uuid);
          return;
        }

        //>跳转支付页
        let pay_type = "";
        if (pay_param.use_wechat) {
          pay_type = "wechat";
        }
        if (pay_param.use_alipay) {
          pay_type = "alipay";
        }
        if (pay_param.use_offline) {
          pay_type = "offline";
        }
        const route_param = {};
        route_param.uuid = checkout.data.uuid;
        route_param.pay_type = pay_type;
        console.log("route_param", route_param);
        this.$router.push({
          name: "MallPayOrder",
          query: route_param,
        });
      } catch (e) {
        console.warn("err-order-pay", e);
      }
    },
    payBalance(uuid) {
      const param = {};
      param.uuid = uuid;
      param.pay_type = "balance";
      param.usePointDeduct = this.usePointDeduct;
      this.$Spin.show();
      orderPay(param)
        .then((res) => {
          console.log("res-pay", res);
          this.$layer.msg("支付成功");
          this.$router.replace({
            name: "MallPayResult",
            query: { uuid: uuid },
          });
        })
        .catch((e) => {
          console.log("err-pay", e);
          this.$layer.msg(e.msg);
        })
        .finally(() => {
          this.$Spin.hide();
        });
    },
    async onOrderEstimate() {
      try {
        const { data } = await orderEstimate(this.form);
        console.log("data-order-estimate", data);
        this.goods_list = data.base_data;
        this.pay_items = data.total_data;
      } catch (e) {
        this.$layer.msg(e.msg);
        console.log("err-order-estimate", e);
      }
    },
    close() {
      this.reset();
    },
    reset() {
      this.form_data = { ...form_data };
      this.value = [];
    },
    save() {
      this.form_data.province = this.value[0];
      this.form_data.city = this.value[1];
      this.form_data.zone = this.value[2];
      if (!this.form_data.contact_person) {
        this.$layer.msg("请输入姓名");
        return;
      }
      if (!this.form_data.contact_mobile) {
        this.$layer.msg("请输入手机号");
        return;
      }
      if (!checkMobile(this.form_data.contact_mobile.trim())) {
        this.$layer.msg('请输入正确的手机号');
        return;
      }
      if (!this.form_data.province) {
        this.$layer.msg("请选择省份");
        return;
      }
      if (!this.form_data.city) {
        this.$layer.msg("请选择城市");
        return;
      }
      if (!this.form_data.zone) {
        this.$layer.msg("请选择区县");
        return;
      }
      if (!this.form_data.address) {
        this.$layer.msg("请输入详细地址");
        return;
      }

      SaveAddress(this.form_data)
        .then(() => {
          this.$layer.msg(`保存成功`);
          this.reset();
          this.is_popup_show = false;
        })
        .finally(() => {
          this.onGetAddressList();
          // 新增或修改地址后，订单已存在同步地址重算运费，否则实时估算运费、付款等信息
          if (this.form.from == "order-list") {
            this.recalculateOrderFreight();
          } else {
            this.onOrderEstimate();
          }
        });
    },
    add_address() {
      if(this.address_list.length < 1){
        this.form_data.is_default = 1;
      }
      this.is_popup_show = true;
    },
    edit_address(id) {
      GetAddress({ id }).then((response) => {
        this.form_data = response.data;
        this.value = [
          this.form_data.province,
          this.form_data.city,
          this.form_data.zone,
        ];
        this.is_popup_show = true;
      });
    },
    selectAddress(item) {
      if (this.form.address_id == item.id) return;
      this.form.address_id = item.id;
      // 订单已存在（重新支付）：同步订单地址并重算运费，再拉取详情
      if (this.form.from == "order-list") {
        this.recalculateOrderFreight();
      } else {
        this.onOrderEstimate();
      }
    },
    async onGetAddressList() {
      try {
        const { code, msg, data } = await AddressList();
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        console.log("data", data);
        const sortedData = [...data].sort((a, b) => {
          // 如果a是默认地址，b不是默认地址，则a排在前面
          if (a.is_default > 0 && b.is_default <= 0) {
            return -1;
          }
          // 如果b是默认地址，a不是默认地址，则b排在前面
          if (b.is_default > 0 && a.is_default <= 0) {
            return 1;
          }
          // 如果都是默认地址或都不是默认地址，则保持原有顺序
          return 0;
        });

        const default_id = sortedData.find((item) => item.is_default)?.id;
        const selectedId = this.form.address_id;
        const selectedStillExists = sortedData.some(
          (item) => item.id == selectedId
        );
        // 保持原地址选择；仅当未选择或已选地址已不存在时，才回退到默认地址
        if (!selectedId || !selectedStillExists) {
          this.form.address_id = default_id || "";
        }
        this.address_list = sortedData;
      } catch (e) {
        console.log("err-address-list", e);
      }
    },
    // 余额支付是否为禁用态：余额为0时禁选并置灰
    isPayDisabled(item) {
      if (item.type !== "balance") return false;
      return Number(this.userInfo.available_balance || 0) === 0;
    },
    // 当前余额与应付金额的关系，决定支付方式的可选组合（与小程序一致）
    // 1) 余额足够支付 finalPayPrice：余额/微信/支付宝三者互斥，只能选其一
    // 2) 余额为0：余额禁选（置灰）
    // 3) 余额不为0且不足：余额可与微信/支付宝组合（微信/支付宝互斥）
    change_payment(item) {
      // 线下支付为整单独立支付方式，与其它互斥
      if (item.type === "offline") {
        const next = !item.checked;
        this.pay_list.forEach((i) => {
          i.checked = false;
        });
        item.checked = next;
        return;
      }
      const balance = Number(this.userInfo.available_balance || 0);
      const finalPayPrice = Number(this.finalPayPrice || 0);
      const balanceZero = balance === 0;
      const balanceEnough = balance >= finalPayPrice; // 含应付为0视为足够
      // 余额为0：余额禁选
      if (item.type === "balance" && balanceZero) return;
      // 已选中再次点击 = 取消
      if (item.checked) {
        item.checked = false;
        return;
      }
      if (item.type === "balance") {
        // 余额足够时与微信/支付宝互斥：取消其它已选
        if (balanceEnough) {
          this.pay_list.forEach((i) => {
            if (i.type !== "balance") i.checked = false;
          });
        }
        // 余额不足时可与微信/支付宝组合（微信/支付宝互斥）
        item.checked = true;
      } else if (item.type === "wechat" || item.type === "alipay") {
        this.pay_list.forEach((i) => {
          // 微信/支付宝互斥
          if ((i.type === "wechat" || i.type === "alipay") && i.type !== item.type)
            i.checked = false;
          // 余额足够时与余额互斥
          if (balanceEnough && i.type === "balance") i.checked = false;
          // 与线下支付互斥
          if (i.type === "offline") i.checked = false;
        });
        item.checked = true;
      }
    },
    // finalPayPrice 动态变化时，实时纠正已选支付方式，避免出现非法组合：
    // - 余额为0：确保余额未选中
    // - 余额足够：三者只能保留其一（优先级：余额 > 微信 > 支付宝）
    normalizePayType() {
      const balance = Number(this.userInfo.available_balance || 0);
      const balanceZero = balance === 0;
      const balanceEnough = balance >= Number(this.finalPayPrice || 0);
      if (balanceZero) {
        const b = this.pay_list.find((i) => i.type === "balance");
        if (b) b.checked = false;
      }
      if (balanceEnough) {
        const checked = this.pay_list.filter((i) => i.checked);
        if (checked.length > 1) {
          const keep =
            this.pay_list.find((i) => i.checked && i.type === "balance") ||
            this.pay_list.find((i) => i.checked && i.type === "wechat") ||
            this.pay_list.find((i) => i.checked && i.type === "alipay");
          this.pay_list.forEach((i) => {
            if (i !== keep) i.checked = false;
          });
        }
      }
    },
    // onCartNumChange(type, { uuid, num, stock }, index, cart_index) {
    //   if (type === "minus") {
    //     if (num <= 1) {
    //       this.$layer.msg("商品数量不能少于1");
    //       return;
    //     }
    //     num--;
    //     this.list[index].cart_list[cart_index].num = num;
    //   }
    //   if (type === "plus") {
    //     if (num >= stock) {
    //       this.$layer.msg("商品库存不足");
    //       return;
    //     }
    //     num++;
    //     this.list[index].cart_list[cart_index].num = num;
    //   }
    //   const param = {};
    //   param.uuid = uuid;
    //   param.num = num;
    //   console.log("param", param);
    //   this.syncCartNum(param);
    // },
    // syncCartNum: _.debounce(async function (param) {
    //   console.log("param", param, "time", new Date());
    //   // return;
    //   try {
    //     const { code, msg } = await cartChange(param);
    //     console.log("code", code, "msg", msg);
    //     if (code > 0) {
    //       this.$layer.msg(msg);
    //       return;
    //     }
    //   } catch (e) {
    //     console.log("cart-change-err", e);
    //     this.$layer.msg(e.msg);
    //   }
    //   // this.onGetCartList();
    // }, 300),
  },
};
</script>
<style lang="scss" scoped>
.check-out {
  width: 100%;
  min-height: 100vh;
  background: rgb(246, 247, 250);
  padding-bottom: 160px;
  .checkout-container {
    padding: 0 160px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
    min-height: 1px;
    box-sizing: border-box;
    .page-title {
      width: 100%;
      margin-top: 33px;
      color: #1f1f1f;
      font-size: 26px;
      font-weight: bold;
    }
    .checkout-left {
      max-width: 1180px;
      flex: 1;
      min-width: 0;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      margin-top: 24px;
      row-gap: 20px;
      .address-box {
        width: 100%;
        min-height: 220px;
        background: #ffffff;
        border-radius: 10px;
        .address-container {
          padding: 25px 20px;
          display: flex;
          flex-direction: column;
          width: 100%;
          row-gap: 25px;
          .address-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .top-title {
              color: #333333;
              font-size: 18px;
              font-weight: 500;
            }
            .top-btn-box {
              display: flex;
              column-gap: 10px;
              .btn-items {
                color: #1f1f1f;
                font-size: 14px;
                cursor: pointer;
              }
            }
          }
          .address-list {
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            column-gap: 12px;
            row-gap: 10px;
            .address-item {
              flex-shrink: 0;
              width: 276px;
              height: 88px;
              border: 1px solid #e3e3e3;
              border-radius: 6px;
              display: flex;
              column-gap: 10px;
              padding: 15px;
              cursor: pointer;
              position: relative;
              overflow: hidden;
              .edit-icon {
                position: absolute;
                right: 0;
                bottom: 0;
                background: #f3f6f8;
                size: 12px;
                padding: 3px 10px;
                color: #191a1c;
                border-radius: 6px 0px 6px 0px;
                display: none;
              }
              &:hover,
              &.active {
                border: 1px solid #fa3d5a;
              }
              &:hover {
                .edit-icon {
                  display: block;
                }
              }
              .address-item-icon {
                width: 20px;
                height: 24px;
              }
              .address-item-content {
                display: flex;
                flex-direction: column;
                flex: 1;
                overflow: hidden;
                .top-content {
                  color: #191a1c;
                  font-size: 12px;
                  display: flex;
                  justify-content: flex-start;
                  column-gap: 5px;
                  span {
                    &.is-default {
                      background: #fa3d5a;
                      color: #ffffff;
                      border-radius: 5px;
                      text-align: center;
                      padding: 0 5px;
                    }
                    // flex:1;
                    width: fit-content;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  }
                }
                .address-content {
                  width: 100%;
                  color: #191a1c;
                  font-size: 14px;
                  font-weight: bold;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .address-name-phone {
                  color: #191a1c;
                  font-size: 12px;
                  display: flex;
                  column-gap: 10px;
                  span {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                }
              }
            }
          }
          .show-all-btn {
            display: flex;
            align-items: center;
            column-gap: 3px;
            color: #7c889c;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.3s ease;
            .arrow-transform {
              transform: rotate(180deg);
            }
            ::v-deep .ivu-icon {
              transition: transform 0.3s ease;
            }
          }
        }
      }
      .product-box {
        width: 100%;
        background: #ffffff;
        border-radius: 10px;
        .product-list {
          padding: 24px 20px 30px 20px;
          display: flex;
          flex-direction: column;
          width: 100%;
          .list-title {
            color: #333333;
            font-size: 18px;
            font-weight: 500;
            margin-bottom: 26px;
          }
          table {
            width: 100%;
            border-collapse: separate;
            border-spacing: 0;
            // table-layout:fixed;
            border: 1px solid #ebebeb;
            border-radius: 10px;
            overflow: hidden;
            margin-bottom: 17px;
            tr > td {
              padding: 20px 30px 20px 20px;
            }
            .product-shop-title {
              width: 100%;
              display: flex;
              align-items: center;
              column-gap: 8px;
              padding: 20px;
              background: #f6f7fa;
              .icon-shop,
              .service-icon {
                width: 24px;
                height: 24px;
              }
              .shop-name {
                color: #333333;
                font-size: 14px;
              }
            }
            .product-info-column {
              display: flex;
              column-gap: 13px;
              // margin-left:20px;
              .cover {
                width: 96px;
                height: 96px;
                background: #f5f5f5;
                border-radius: 8px;
              }
              .text-box {
                display: flex;
                flex-direction: column;
                text-align: left;
                .product-name {
                  color: #333333;
                  font-size: 14px;
                  font-weight: 500;
                  -webkit-line-clamp: 2;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .product-spec {
                  display: flex;
                  align-items: center;
                  color: #666666;
                  font-size: 14px;
                }
              }
            }
            .num-column {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 104px;
              flex-shrink: 0;
              overflow: hidden;
              height: 32px;
              // border:1px solid #d6d6d6;
              // border-radius:1px;
              .minus-btn,
              .plus-btn {
                width: 32px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                font-size: 20px;
                color: #333333;
                cursor: pointer;
                user-select: none;
                flex-shrink: 0;
                &.can-not {
                  color: #b7bac0;
                  cursor: not-allowed;
                }
              }
              .num-input {
                width: calc(100% - 64px);
                height: 32px;
                line-height: 32px;
                text-align: center;
                font-size: 16px;
                color: #333333;
                border: none;
                border-left: 1px solid #d6d6d6;
                border-right: 1px solid #d6d6d6;
                outline: none;
              }
            }
            .price-column {
              display: flex;
              flex-direction: column;
              text-align: right;
              .price {
                color: #fa3d5a;
                font-size: 16px;
                font-weight: bold;
              }
              .tag-price {
                color: #999999;
                font-size: 13px;
              }
              .logistics-price {
                color: #999999;
                font-size: 13px;
                line-height: 30px;
                span {
                  color: #fa3d5a;
                }
              }
            }
          }
        }
      }
    }
    .checkout-right {
      // min-width: 360px;
      flex: 0 0 360px;
      height: fit-content;
      background: #ffffff;
      border-radius: 10px;
      margin-top: 24px;
      position: sticky;
      top: 12%;
      overflow: hidden;
      .right-box-container {
        padding: 20px;
        display: flex;
        flex-direction: column;
        .right-top-title {
          color: #1f1f1f;
          font-size: 18px;
          font-weight: 500;
          display: flex;
          align-items: flex-end;
          column-gap: 10px;
          .product-count {
            color: #575859;
            font-size: 12px;
            span {
              color: #333333;
              font-size: 14px;
              padding: 0 3px;
            }
          }
        }
        .right-product-imgs {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 22px;
          .product-img {
            width: 74px;
            height: 74px;
            border-radius: 5px;
            background: #f5f5f5;
          }
        }
        .pay-list {
          width: 100%;
          margin-top: 30px;
          padding-bottom: 20px;
          border-bottom: 1px solid #ebebeb;
          .pay-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            line-height: 30px;
            .pay-item-label {
              color: #575859;
              font-size: 14px;
            }
            .pay-item-value {
              color: #1f1f1f;
              font-size: 14px;
              font-weight: bold;
            }
          }
        }
        .integral {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .checkbox-label {
            color: #1f1f1f;
            font-size: 14px;
            line-height: 53px;
            span {
              color: #666666;
              font-size: 12px;
              line-height: 53px;
            }
          }
          .checkbox-value {
            color: #1f1f1f;
            font-size: 14px;
            font-weight: bold;
          }
        }
        .pay-type-box {
          width: 100%;
          border-radius: 10px;
          background: #f6f7fa;
          .pay-type-wrapper {
            padding: 28px 20px;
            display: flex;
            flex-direction: column;
            row-gap: 15px;
            .pay-type-item {
              display: flex;
              align-items: center;
              column-gap: 10px;
              // line-height:53px;
              .pay-type-icon {
                width: 20px;
                height: 20px;
              }
              .pay-type-name {
                color: #1f1f1f;
                font-size: 14px;
              }
              &.pay-disabled {
                opacity: 0.45;
                cursor: not-allowed;
              }
            }
          }
        }
        .pay-total {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-weight: bold;
          margin-top: 32px;
          .pay-total-label {
            color: #575859;
            font-size: 16px;
          }
          .pay-total-value {
            color: #fa3d5a;
            font-size: 20px;
          }
        }
        .pay-btn-box {
          width: 100%;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          column-gap: 9px;
          font-size: 16px;
          font-weight: 500;
          line-height: 50px;
          text-align: center;
          margin-top: 39px;
          .back-btn {
            width: 120px;
            height: 100%;
            border: 1px solid #e3e3e3;
            border-radius: 10px;
            color: #1f1f1f;
            cursor: pointer;
          }
          .pay-btn {
            width: 190px;
            height: 100%;
            border-radius: 10px;
            background: #fa3d5a;
            color: #ffffff;
            cursor: pointer;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1280px) and (max-width: 1679px) {
  .check-out {
    .checkout-container {
      padding: 0 100px;

      .checkout-left {
        width: calc(100% - 380px); // 减去右侧栏最小宽度

        .address-list {
          flex-wrap: wrap;
          .address-item {
            flex-shrink: 0;
            width: calc(50% - 6px); // 两列布局
            &:nth-child(n + 3) {
              display: none; // 只显示前两个地址项
            }
          }
        }
      }
    }
  }
}

// 媒体查询：针对小屏幕 (最大1279px)
@media screen and (max-width: 1279px) {
  .check-out {
    padding-bottom: 80px;

    .checkout-container {
      padding: 0 60px;
      flex-direction: row; /* 保持横向布局 */

      .page-title {
        margin-top: 33px;
        font-size: 26px;
      }

      .checkout-left {
        width: calc(100% - 380px); /* 根据右侧宽度动态计算 */
        margin-top: 24px;

        .address-box {
          .address-container {
            padding: 25px 20px;

            .address-top {
              flex-direction: row;
              align-items: center;

              .top-btn-box {
                align-self: auto;
              }
            }

            .address-list {
              flex-wrap: wrap;

              .address-item {
                width: calc(25% - 9px); /* 根据数量调整宽度 */
                margin-bottom: 0;
              }
            }

            .show-all-btn {
              justify-content: flex-start;
            }
          }
        }

        .product-box {
          .product-list {
            padding: 24px 20px 30px 20px;

            .list-title {
              margin-bottom: 26px;
            }

            table {
              margin-bottom: 17px;

              tr > td {
                padding: 20px 30px 20px 20px;
              }

              .product-info-column {
                column-gap: 13px;

                .cover {
                  width: 96px;
                  height: 96px;
                }

                .text-box {
                  .product-name {
                    font-size: 14px;
                  }

                  .product-spec {
                    font-size: 14px;
                  }
                }
              }

              .num-column {
                width: 104px;
                height: 32px;

                .minus-btn,
                .plus-btn {
                  width: 32px;
                  height: 32px;
                  line-height: 32px;
                  font-size: 20px;
                }

                .num-input {
                  width: calc(100% - 64px);
                  height: 32px;
                  line-height: 32px;
                  font-size: 16px;
                }
              }
            }
          }
        }
      }

      .checkout-right {
        min-width: 360px;
        margin-top: 24px;
        position: sticky;
        top: 12%;

        .right-box-container {
          padding: 20px;

          .pay-btn-box {
            flex-direction: row;
            row-gap: 0;
            margin-top: 39px;

            .back-btn {
              width: 120px;
            }

            .pay-btn {
              width: 190px;
            }
          }
        }
      }
    }
  }
}

::v-deep .popup-modal {
  display: flex;
  flex-direction: column;
  h2 {
    padding: 10px 20px;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid #f0f0f0;
  }
  .form {
    flex: 1;
    padding: 10px 0;
    .form-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      align-items: center;
      margin-top: 20px;
      width: 100%;
      .form-label {
        // flex:1;
        flex-shrink: 0;
        max-width: 100px;
        font-size: 14px;
        color: #696a6a;
        text-align: right;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .form-control {
        position: relative;
        flex: 1;
        .input {
          // width: 300px;
          width: 100%;
          // max-width:300px;
          height: 48px;
          line-height: 48px;
          border: 1px solid #d9d9d9;
          border-radius: 5px;
          padding: 0 10px;
          outline: none;
          font-size: 14px;
          &[readonly] {
            border: none;
          }
        }
        textarea {
          // width: 300px;
          flex: 1;
          height: 100px;
          border: 1px solid #d9d9d9;
          padding: 5px;
        }
      }
    }

    .btn-submit {
      margin: 40px 0 0 40px;
      width: 110px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #fa3d5a;
      color: white;
      border-radius: 6px;
      cursor: pointer;
    }
  }
}
</style>
